import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_POLICY_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_POLICY_TYPE = 'postermywall-policy';
const FORM_TEXT_DATA_ATTR = 'data-is-pmw-form-text';
const FOOTNOTE_DATA_ATTR = 'data-is-signup-form-footnote';

const DEFAULT_POLICY_CONTENT = 'By submitting this form, you are consenting to receive marketing emails. You may unsubscribe at any time.';

export const POSTERMYWALL_POLICY: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.getAttribute(FOOTNOTE_DATA_ATTR) !== null ? {type: POSTERMYWALL_POLICY_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'p',
      highlightable: false,
      selectable: false,
      draggable: false,
      hoverable: false,
      badgable: false,
      copyable: false,
      toolbar: [],
      content: DEFAULT_POLICY_CONTENT,
      attributes: {
        'data-pmw-type': POSTERMYWALL_POLICY_TYPE,
        [FORM_TEXT_DATA_ATTR]: '1',
        [FOOTNOTE_DATA_ATTR]: '1',
      },
      style: FORM_POLICY_STYLES,
    },
  },
};
